import React, { useEffect, useState } from 'react';

import { DarkButton } from '../../../components/dark-button';
import LottieHelper from '../../../components/LottieHelper';
import styles from './takeselfiemodal.module.css';
import { t } from 'i18next';

interface TakeSelfieModalProps {
	show: boolean;
	onClose: () => void;
	onUnderstand: () => void | Promise<void>;
	loading?: boolean;
}

const TakeSelfieModal: React.FC<TakeSelfieModalProps> = ({
	show,
	onClose,
	onUnderstand,
	loading = false,
}) => {
	const [buttonLoading, setButtonLoading] = useState(false);

	useEffect(() => {
		if (!show) {
			setButtonLoading(false);
			return;
		}

		// if (!loading) {
		// 	setButtonLoading(false);
		// }
	}, [show, loading]);

	const handleUnderstandClick = async () => {
		setButtonLoading(true);
		try {
			await onUnderstand();
		} catch (error) {
			setButtonLoading(false);
			throw error;
		}
	};

	if (!show) return null;

	return (
		<div className={styles.modalOverlay}>
			<div className={styles.modalContent}>
				<div className={styles.verificationWrapper}>
					<div className={styles.verificationCard}>
						<LottieHelper animationData="remove-face.json" />
					</div>
				</div>

				<p
					className="text-center p-2"
					style={{
						color: '#050505',
						fontWeight: 700,
					}}>
					{t('TakeSelfiePopUpMessage')}

					<br />
				</p>

				{/* VERTICAL BUTTONS */}
				<div className="d-flex flex-column gap-2 mt-1 theme-selfie-understand">
					<DarkButton
						text="Understand"
						filled
						hideArrow
						onClick={handleUnderstandClick}
						className="det-proceed-button"
						loader={buttonLoading || loading}
					/>
				</div>
				{/* <div className="d-flex flex-column gap-2 mt-1 theme-close">
					<DarkButton text="Close" filled={false} hideArrow onClick={onClose} />
				</div> */}
			</div>
		</div>
	);
};
export default TakeSelfieModal;
